import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { TreatmentLength } from 'application/types';
import * as React from 'react';
import { useContextTranslation } from 'ui/translation';

interface TreatmentLengthSelectorProps {
  onClick: () => any;
  expanded: boolean;
  treatmentLength: TreatmentLength | null;
}

const TreatmentLengthSelectorWrapper: React.FC<TreatmentLengthSelectorProps> = ({
  onClick,
  expanded,
  treatmentLength: selectedLength,
  children,
}) => {
  const t = useContextTranslation('page.treatment');

  const shouldDisplaySelectedLength = selectedLength && !expanded;

  return (
    <section
      className={`button-selector expandable-select treatment-length${
        expanded ? ' expanded' : ''
      }`}
    >
      <button
        type="button"
        className={`expand-button${
          shouldDisplaySelectedLength ? ' selected' : ''
        }`}
        onClick={onClick}
      >
        <div className="icon-container">
          <FontAwesomeIcon icon={faClock} />
        </div>
        <div className="text-container">
          {shouldDisplaySelectedLength && selectedLength ? (
            <span>
              {t('length_minutes', { length: selectedLength.length })}
            </span>
          ) : (
            t('treatment_length_select')
          )}
        </div>
        <div className="arrow-container">
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </button>
      {children}
    </section>
  );
};

export default TreatmentLengthSelectorWrapper;
